<script setup lang="ts">
defineProps<{
  title: string
  icon?: string
}>();
</script>

<template>
  <UCard
    :ui="{ root: 'bg-default ring ring-default overflow-hidden rounded-lg divide-y-0', header: '!px-4 !py-3', body: '!p-0' }">
    <template #header>
      <div class="flex items-center justify-between">
        <div class="flex items-center gap-2">
          <div v-if="icon" class="rounded ring ring-default w-6 h-6 flex items-center justify-center">
            <UIcon :name="icon" />
          </div>
          <span class="text-sm font-medium">{{ title }}</span>
        </div>
        <div class="leading-none">
          <slot name="right" />
        </div>
      </div>
    </template>
    <div class="border-t border-dashed border-default mx-4"></div>
    <div class="px-4 py-3">
      <slot />
    </div>
  </UCard>
</template>
